module.exports = "/static/media/cancel_icon.c160a9ae.svg";